export default class IncomeAndExpensesCalculator {

    constructor() {
        this.rentalIncomeAmount = 0;
        this.rentalIncomePercentage = 0;
        this.rentalIncomeAnnual = this.rentalIncomeAmount * 52;
        this.councilRates = 2400;
        this.buildingInsuranceOrStrataFees = 2000;
        this.otherExpenses = 0;
        this.propertyManagement = 7.7;
        this.propertyManagementAmount = 0;
        this.vacancyPeriod = 2;
        this.totalCalc = 0;
        this.loanAmount = 0;
        this.loanToValueRatio = 0;
        this.loanType = 'Principal & Interest';
        this.loanTerm = 30;
        this.lendersMortgageInsurance = 0;
        this.lendersMortgageInsuranceTable =
            [[0.475, 0.568, 0.904, 0.904, 0.913],
             [0.485, 0.568, 0.904, 0.904, 0.913],
             [0.596, 0.699, 0.932, 1.09, 1.109],
             [0.662, 0.829, 0.96, 1.09, 1.146],
             [0.727, 0.969, 1.165, 1.333, 1.407],
             [0.876, 1.081, 1.258, 1.407, 1.463],
             [0.932, 1.146, 1.407, 1.631, 1.733],
             [1.062, 1.305, 1.463, 1.631, 1.752],
             [1.295, 1.621, 1.948, 2.218, 2.395],
             [1.463, 1.873, 2.18, 2.367, 2.516],
             [2.013, 2.618, 3.513, 3.783, 3.82],
             [2.013, 2.674, 3.569, 3.867, 3.932],
             [2.33, 3.028, 3.802, 4.081, 4.156],
             [2.376, 3.028, 3.802, 4.286, 4.324],
             [2.609, 3.345, 4.00, 4.613, 4.603]];
        this.interestRate = 0;
        this.annualInterestRepayments = 0;
        this.annualPrincipalRepayments = 0;
        this.annualInterestOnEquityFunds = 0;
        this.totalExpensesCalc = 0;
        this.PITable = [];
        this.PITableTotal = 0;
    }

    copyOtherIncomeAndExpensesCalculator(incomeAndExpenses) {
        this.rentalIncomeAmount = incomeAndExpenses.rentalIncomeAmount;
        this.rentalIncomePercentage = incomeAndExpenses.rentalIncomePercentage;
        this.rentalIncomeAnnual = incomeAndExpenses.rentalIncomeAnnual;
        this.councilRates = incomeAndExpenses.councilRates;
        this.buildingInsuranceOrStrataFees = incomeAndExpenses.buildingInsuranceOrStrataFees;
        this.otherExpenses = incomeAndExpenses.otherExpenses;
        this.propertyManagement = incomeAndExpenses.propertyManagement;
        this.propertyManagementAmount = incomeAndExpenses.propertyManagementAmount;
        this.vacancyPeriod = incomeAndExpenses.vacancyPeriod;
        this.totalCalc = incomeAndExpenses.totalCalc;
        this.loanAmount = incomeAndExpenses.loanAmount;
        this.loanToValueRatio = incomeAndExpenses.loanToValueRatio;
        this.loanType = incomeAndExpenses.loanType;
        this.loanTerm = incomeAndExpenses.loanTerm;
        this.lendersMortgageInsurance = incomeAndExpenses.lendersMortgageInsurance;
        this.interestRate = incomeAndExpenses.interestRate;
        this.annualInterestRepayments = incomeAndExpenses.annualInterestRepayments;
        this.annualPrincipalRepayments = incomeAndExpenses.annualPrincipalRepayments;
        this.annualInterestOnEquityFunds = incomeAndExpenses.annualInterestOnEquityFunds;
        this.totalExpensesCalc = incomeAndExpenses.totalExpensesCalc;
        this.PITable = incomeAndExpenses.PITable;
        this.PITableTotal = incomeAndExpenses.PITableTotal;
    }

    calcPITable() {
        this.PITableTotal = this.calcPITableTotal(this.interestRate, this.loanTerm, this.loanAmount);

        if (isNaN(this.PITableTotal)) {
            this.PITableTotal = 0;
        }

        if (this.PITableTotal >= 0) {
            for (var i = 0; i < 120; i++) {

                var currentMonth = i + 1;
                var currentInterest = this.calcPITableCurrentInterest(this.interestRate, currentMonth, this.loanAmount);
                var currentPrincipal = this.calcPITableCurrentPrincipal(currentInterest);

                var previousLoanBalance = 0;
                if (i === 0) {
                    previousLoanBalance = this.loanAmount;
                } else {
                    previousLoanBalance = this.PITable[i - 1].loanBalance;
                }

                var currentLoanBalance = this.calcPITableCurrentLoanBalance(previousLoanBalance, currentPrincipal);

                this.PITable[i] = {
                    month: currentMonth,
                    total: this.PITableTotal,
                    interest: currentInterest,
                    principal: currentPrincipal,
                    loanBalance: currentLoanBalance
                };
            }
            this.roundPITableValues();
        }

        this.calcAnnualInterestRepayments();
        this.calcAnnualPrincipalRepayments();
    }

    roundPITableValues() {

        if (Math.floor(this.PITableTotal) !== Number(this.PITableTotal)) {
            if (this.PITableTotal.toString().split(".")[1].length > 2) {
                this.PITableTotal = Number(Math.round(Number(this.PITableTotal + 'e' + 2)) + 'e-' + 2);
            }
        }

        for (var i = 0; i < 120; i++) {

            this.PITable[i].total = this.PITableTotal;

            if (Math.floor(this.PITable[i].interest) !== Number(this.PITable[i].interest)) {
                if (this.PITable[i].interest.toString().split(".")[1].length > 2) {
                    this.PITable[i].interest = Number(Math.round(Number(this.PITable[i].interest + 'e' + 2)) + 'e-' + 2);
                }
            }

            if (Math.floor(this.PITable[i].principal) !== Number(this.PITable[i].principal)) {
                if (this.PITable[i].principal.toString().split(".")[1].length > 2) {
                    this.PITable[i].principal = Number(Math.round(Number(this.PITable[i].principal + 'e' + 2)) + 'e-' + 2);
                }
            }

            if (Math.floor(this.PITable[i].loanBalance) !== Number(this.PITable[i].loanBalance)) {
                if (this.PITable[i].loanBalance.toString().split(".")[1].length > 2) {
                    this.PITable[i].loanBalance = Number(Math.round(Number(this.PITable[i].loanBalance + 'e' + 2)) + 'e-' + 2);
                }
            }
        }
    }

    calcPITableTotal(rate, nper, pv) {
        return  ( rate/100/12 * pv) / (1 - Math.pow((1 + rate/100/12), -nper*12));
    }

    calcPITableCurrentInterest(rate, month, pv) {
        return  this.PITableTotal + Math.pow((1+rate/100/12),(month-1)) *(pv * rate/100/12 - this.PITableTotal);
    }

    calcPITableCurrentPrincipal(currentInterest) {
        return  this.PITableTotal - currentInterest;
    }

    calcPITableCurrentLoanBalance(previousLoanBalance, currentPrincipal) {
        return  previousLoanBalance - currentPrincipal;
    }

    getLoanBalanceTable() {
        var loanBalanceTable = [];

        for (var i = 11; i < 120; i += 12) {
            if (this.PITable[i] != null) {
                loanBalanceTable.push(this.PITable[i].loanBalance);
            }
        }

        return loanBalanceTable;
    }

    setRentalIncomeAmount(rentalIncomeAmount) {
        this.rentalIncomeAmount = Number(rentalIncomeAmount);
        this.calcRentalIncomeAnnual();
    }

    getRentalIncomeAmount() {
        return this.rentalIncomeAmount;
    }

    calcRentalIncomeAmount() {
        this.rentalIncomeAmount = this.rentalIncomeAnnual / 52;
        if (Math.floor(this.rentalIncomeAmount) !== this.rentalIncomeAmount) {
            this.rentalIncomeAmount = Math.round(this.rentalIncomeAmount);
        }
        this.setTotal();
    }

    setRentalIncomePercentage(rentalIncomePercentage) {
        this.rentalIncomePercentage = Number(rentalIncomePercentage);
        this.setTotal();
    }

    getRentalIncomePercentage() {
        return this.rentalIncomePercentage;
    }

    calcRentalIncomePercentage(purchasePrice) {
        this.rentalIncomePercentage = (this.rentalIncomeAnnual * 100) / Number(purchasePrice);
        if (Math.floor(this.rentalIncomePercentage) !== Number(this.rentalIncomePercentage)) {
            if (this.rentalIncomePercentage.toString().split(".")[1].length > 1) {
                this.rentalIncomePercentage = Number(Math.round(Number(this.rentalIncomePercentage+'e'+1))+'e-'+1);
            }
        }
        this.setTotal();
    }

    setRentalIncomeAnnual(rentalIncomeAnnual) {
        this.rentalIncomeAnnual = Number(rentalIncomeAnnual);
        this.calcPropertyManagementAmount();
    }

    getRentalIncomeAnnual() {
        return this.rentalIncomeAnnual;
    }

    calcRentalIncomeAnnual() {
        this.rentalIncomeAnnual = this.rentalIncomeAmount * 52;
        this.calcPropertyManagementAmount();
    }

    calcRentalIncomeAnnualByRentalIncomePercentage(purchasePrice) {
        this.rentalIncomeAnnual = Number(purchasePrice) * (this.rentalIncomePercentage / 100);
        if (Math.floor(this.rentalIncomeAnnual) !== this.rentalIncomeAnnual) {
            this.rentalIncomeAnnual = Math.round(this.rentalIncomeAnnual);
        }
        this.calcRentalIncomeAmount();
    }

    setCouncilRates(councilRates) {
        this.councilRates = Number(councilRates);
        this.setTotal();
    }

    getCouncilRates() {
        return this.councilRates;
    }

    setBuildingInsuranceOrStrataFees(buildingInsuranceOrStrataFees) {
        this.buildingInsuranceOrStrataFees = Number(buildingInsuranceOrStrataFees);
        this.setTotal();
    }

    getBuildingInsuranceOrStrataFees() {
        return this.buildingInsuranceOrStrataFees;
    }

    setOtherExpenses(otherExpenses) {
        this.otherExpenses = Number(otherExpenses);
        this.setTotal();
    }

    getOtherExpenses() {
        return this.otherExpenses;
    }

    setPropertyManagement(propertyManagement) {
        this.propertyManagement = Number(propertyManagement);
        this.calcPropertyManagementAmount();
    }

    getPropertyManagement() {
        return this.propertyManagement;
    }

    getPropertyManagementAmount() {
        return this.propertyManagement;
    }

    calcPropertyManagementAmount() {
        this.propertyManagementAmount = (this.propertyManagement * this.rentalIncomeAnnual) / 100;
        if (Math.floor(this.propertyManagementAmount) !== this.propertyManagementAmount) {
            this.propertyManagementAmount = Math.round(this.propertyManagementAmount);
        }
        this.setTotal();
    }

    setVacancyPeriod(vacancyPeriod) {
        this.vacancyPeriod = Number(vacancyPeriod);
        this.setTotal();
    }

    getVacancyPeriod() {
        return this.vacancyPeriod;
    }

    setTotal() {
        this.totalCalc = this.councilRates + this.buildingInsuranceOrStrataFees + this.otherExpenses
            + this.propertyManagementAmount + this.vacancyPeriod * this.rentalIncomeAmount;

        this.setTotalExpenses();
    }

    getTotal() {
        return this.totalCalc;
    }

    setLoanAmount(loanAmount) {
        this.loanAmount = Number(loanAmount);
        this.calcPITable();
    }

    getLoanAmount() {
        return this.loanAmount;
    }

    calcLoanAmount(purchasePrice, deposit) {
        this.loanAmount = purchasePrice - deposit;
        this.calcLendersMortgageInsurance();
        this.calcPITable();
    }

    setLoanToValueRatio(loanToValueRatio) {
        this.loanToValueRatio = Number(loanToValueRatio);
        this.calcLendersMortgageInsurance();
    }

    getLoanToValueRatio() {
        return this.loanToValueRatio;
    }

    calcLoanToValueRatio(purchasePrice) {
        this.loanToValueRatio = (this.loanAmount / purchasePrice) * 100;
        if (Math.floor(this.loanToValueRatio) !== Number(this.loanToValueRatio)) {
            if (this.loanToValueRatio.toString().split(".")[1].length > 2) {
                this.loanToValueRatio = Number(Math.round(Number(this.loanToValueRatio+'e'+2))+'e-'+2);
            }
        }
        this.calcLendersMortgageInsurance();
    }

    setLoanType(loanType) {

        if (loanType === 'Principal & Interest' || loanType === 'Interest Only') {
            this.loanType = loanType;
        }

        this.calcAnnualInterestRepayments();
        this.calcAnnualPrincipalRepayments();
    }

    getLoanType() {
        return this.loanType;
    }

    setLoanTerm(loanTerm) {
        this.loanTerm = Number(loanTerm);
        this.calcPITable();
    }

    getLoanTerm() {
        return this.loanTerm;
    }

    setLendersMortgageInsurance(lendersMortgageInsurance) {
        this.lendersMortgageInsurance = Number(lendersMortgageInsurance);
    }

    getLendersMortgageInsurance() {
        return this.lendersMortgageInsurance;
    }

    calcLendersMortgageInsurance() {

        if(this.loanToValueRatio > 80.00 && this.loanAmount <= 1000000) {

            var lvrIndex = Math.ceil(20.00 - (100.00 - this.loanToValueRatio)) - 1;

            var loanAmountIndex;
            if (this.loanAmount < 300000) {
                loanAmountIndex = 0;
            } else if (this.loanAmount < 500000) {
                loanAmountIndex = 1;
            } else if (this.loanAmount < 600000) {
                loanAmountIndex = 2;
            } else if (this.loanAmount < 750000) {
                loanAmountIndex = 3;
            } else if (this.loanAmount <= 1000000) {
                loanAmountIndex = 4;
            }

            if (this.loanToValueRatio <= 95.00) {
                this.lendersMortgageInsurance =
                    (this.lendersMortgageInsuranceTable[lvrIndex][loanAmountIndex] *
                        (this.loanAmount * 100) / this.loanToValueRatio) / 100;

                if (Math.floor(this.lendersMortgageInsurance) !== this.lendersMortgageInsurance) {
                    this.lendersMortgageInsurance = Math.round(this.lendersMortgageInsurance);
                }
            } else {
                this.lendersMortgageInsurance = 0;
            }
        } else {
            this.lendersMortgageInsurance = 0;
        }
    }

    setInterestRate(interestRate) {
        this.interestRate = interestRate;
        this.calcPITable();
    }

    getInterestRate() {
        return this.interestRate;
    }

    setAnnualInterestRepayments(annualInterestRepayments) {
        this.annualInterestRepayments = Number(annualInterestRepayments);
        this.calcAnnualPrincipalRepayments();
        this.setTotalExpenses();
    }

    getAnnualInterestRepayments() {
        return this.annualInterestRepayments;
    }

    calcAnnualInterestRepayments() {

        if (this.loanType === 'Interest Only') {
            this.annualInterestRepayments = (this.loanAmount * this.interestRate) / 100;
        } else if (this.loanType === 'Principal & Interest') {
            this.annualInterestRepayments = 0;
            for (var i = 0; i < 12; i++) {
                if (this.PITable[i] != null) {
                    this.annualInterestRepayments += this.PITable[i].interest;
                }
            }

            if (Math.floor(this.annualInterestRepayments) !== this.annualInterestRepayments) {
                this.annualInterestRepayments = Math.round(this.annualInterestRepayments);
            }
        }

        this.setTotalExpenses();
    }

    setAnnualPrincipalRepayments(annualPrincipalRepayments) {
        this.annualPrincipalRepayments = Number(annualPrincipalRepayments);
        this.setTotalExpenses();
    }

    getAnnualPrincipalRepayments() {
        return this.annualPrincipalRepayments;
    }

    calcAnnualPrincipalRepayments() {

        if (this.loanType === 'Interest Only') {
            this.annualPrincipalRepayments = 0;
        } else if (this.loanType === 'Principal & Interest') {
            this.annualPrincipalRepayments = 0;
            for (var i = 0; i < 12; i++) {
                if (this.PITable[i] != null) {
                    this.annualPrincipalRepayments += this.PITable[i].principal;
                }
            }

            if (Math.floor(this.annualPrincipalRepayments) !== this.annualPrincipalRepayments) {
                this.annualPrincipalRepayments = Math.round(this.annualPrincipalRepayments);
            }

            if (isNaN(this.annualPrincipalRepayments)) {
                this.annualPrincipalRepayments = 0;
            }
        }

        this.setTotalExpenses();
    }

    pmt(rate, nper, pv) {
        return  ( rate/100 * pv) / (1 - Math.pow((1 + rate/100), -nper));
    }

    setAnnualInterestOnEquityFunds(annualInterestOnEquityFunds) {
        this.annualInterestOnEquityFunds = Number(annualInterestOnEquityFunds);
        this.setTotalExpenses();
    }

    getAnnualInterestOnEquityFunds() {
        return this.annualInterestOnEquityFunds;
    }

    calcAnnualInterestOnEquityFunds(depositSource, purchaseCostsTotal) {
        if (depositSource === 'Cash') {
            this.annualInterestOnEquityFunds = 0;
        } else if (depositSource === 'Equity') {
            this.annualInterestOnEquityFunds = (purchaseCostsTotal + this.lendersMortgageInsurance) * (this.interestRate / 100);
            if (Math.floor(this.annualInterestOnEquityFunds) !== this.annualInterestOnEquityFunds) {
                this.annualInterestOnEquityFunds = Math.round(this.annualInterestOnEquityFunds);
            }
        }

        this.setTotalExpenses();
    }

    setTotalExpenses() {
        this.totalExpensesCalc = this.totalCalc + this.annualInterestRepayments
            + this.annualPrincipalRepayments + this.annualInterestOnEquityFunds;
    }

    getTotalExpenses() {
        return this.totalExpensesCalc;
    }
}


// WEBPACK FOOTER //
// ./src/Classes/IncomeAndExpensesCalculator.js